import { useEffect, useState } from 'react';

export const matchesMedia = (query: string) => typeof window.matchMedia === 'function' && window.matchMedia(query).matches;

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(() => matchesMedia(query));
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia(query);
    const update = () => setMatches(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, [query]);
  return matches;
}
